import { FunctionComponent } from "react";
import AboutUsContainer from "../../components/AboutUs/AboutUsContainer";

const AboutUs: FunctionComponent = ({}) => {
  return <AboutUsContainer />;
};

export default AboutUs;
